import isEmail from 'validator/es/lib/isEmail';

export default (message: string = 'Please enter a valid email address.') => (value: string) => {
  const trimmed = value.trim();
  return isEmail(value) && trimmed.length > 0 || message;
};
